import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

const CrewHeader = () => {
  return (
    <div className="mb-10">
      <Link 
        to="/" 
        className="flex items-center text-sm text-muted-foreground hover:text-foreground mb-4 transition-colors"
      >
        <ArrowLeft size={16} className="mr-2" />
        Back to Dashboard
      </Link>
      
      <h1 className="text-4xl font-bold mb-3">Meet Your PageMind Crew</h1>
      <p className="text-xl text-muted-foreground">
        Discover how each agent enhances your website's intelligence and user experience.
      </p>
    </div>
  );
};

export default CrewHeader;